import { render, staticRenderFns } from "./panel-ring.vue?vue&type=template&id=a456f202&scoped=true"
import script from "./panel-ring.vue?vue&type=script&lang=js"
export * from "./panel-ring.vue?vue&type=script&lang=js"
import style0 from "./panel-ring.vue?vue&type=style&index=0&id=a456f202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a456f202",
  null
  
)

export default component.exports